import { render, staticRenderFns } from "./AiChatContent.vue?vue&type=template&id=b1478ad4"
import script from "./AiChatContent.vue?vue&type=script&lang=js"
export * from "./AiChatContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports